import type { AuditLogDTO } from '@src/models/interfaces/AuditLog/AuditLogInterface';
import type { ElasticQueryParams } from '@src/models/interfaces/general/ElasticQueryParams.interface';
import type { ElasticSearchResponse } from '@src/models/interfaces/general/ElasticSearchResponseInterface';

import elasticQueryClient from './ElasticQueryClient';

class AuditLogRepository {
  async all(params: ElasticQueryParams): Promise<ElasticSearchResponse<AuditLogDTO> | null> {
    return elasticQueryClient.query<AuditLogDTO>(params);
  }
}

export default AuditLogRepository;
